"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColor = exports.TextAlign = exports.TextStyle = void 0;
var TextStyle;
(function (TextStyle) {
    TextStyle["MediumBold"] = "medium_bold";
    TextStyle["MediumBoldUnderline"] = "medium_bold--underline";
    TextStyle["MediumDefault"] = "medium_default";
    TextStyle["MediumDefaultUnderline"] = "medium_default--underline";
    TextStyle["MediumSmallBold"] = "medium-small_bold";
    TextStyle["MediumSmallBoldUnderline"] = "medium-small_bold--underline";
    TextStyle["MediumSmallDefault"] = "medium-small_default";
    TextStyle["MediumSmallDefaultUnderline"] = "medium-small_default--underline";
    TextStyle["SmallBold"] = "small_bold";
    TextStyle["SmallBoldUnderline"] = "small_bold--underline";
    TextStyle["SmallDefault"] = "small_default";
    TextStyle["SmallDefaultUnderline"] = "small_default--underline";
    TextStyle["TinyBold"] = "tiny_bold";
    TextStyle["TinyDefault"] = "tiny_default";
    TextStyle["MicroBold"] = "micro_bold";
    TextStyle["MicroDefault"] = "micro_default";
})(TextStyle = exports.TextStyle || (exports.TextStyle = {}));
var TextAlign;
(function (TextAlign) {
    TextAlign["Left"] = "left";
    TextAlign["Center"] = "center";
    TextAlign["Right"] = "right";
})(TextAlign = exports.TextAlign || (exports.TextAlign = {}));
var TextColor;
(function (TextColor) {
    TextColor["DigitalBlack"] = "digital-black";
    TextColor["White"] = "white";
    TextColor["Support20"] = "20";
    TextColor["Support40"] = "40";
    TextColor["Support60"] = "60";
    TextColor["Support80"] = "80";
    TextColor["Support100"] = "100";
    TextColor["AlertLight"] = "alert-light";
    TextColor["AlertStrong"] = "alert-strong";
    TextColor["DisableLightTheme"] = "disable-light-theme";
    TextColor["DisableDarkTheme"] = "disable-dark-theme";
    TextColor["Fail"] = "fail";
    TextColor["FailLight"] = "fail-light";
    TextColor["NotificationLight"] = "notification-light";
    TextColor["NotificationStrong"] = "notification-strong";
    TextColor["Success"] = "success";
    TextColor["SuccessLight"] = "success-light";
})(TextColor = exports.TextColor || (exports.TextColor = {}));
//# sourceMappingURL=Text.types.js.map